// @flow
import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';
import { itemClicked } from '../../../app/browser/analyticsHelpers';

const activityLocation = 'SP : Photos';

const otherProps = {
  serviceProviderId: '[[serviceProviderId]]',
};

const NorthStarStatus = 'isNorthStar';

export default {
  page: {
    name: activityLocation,
    NorthStarStatus,
    properties: {
      ...defaultPageProps,
      ...otherProps,
    },
  },
  elements: {
    'add-images-btn': (itemClicked(activityLocation, 'SP Add Photos', otherProps): any),
    'image-index-card-remove-button-*': (itemClicked(activityLocation, 'Remove Image', otherProps): any),
    'project-showcase-premium-upsell-card-learn-more-button':
      (itemClicked(activityLocation, 'Upgrade,', otherProps): any),
  },
};



// WEBPACK FOOTER //
// ./src/modules/store/browser/imageManagementViewAnalytics.js